import {createStorefrontApiClient} from '@shopify/storefront-api-client';

const client = createStorefrontApiClient({
    storeDomain: process.env.GATSBY_SHOP_NAME,
    apiVersion: process.env.GATSBY_SHOPIFY_STOREFRONT_API_VERSION ?? '2025-01',
    publicAccessToken: process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
});

export default client;
